module.exports = __webpack_public_path__ + "93e123240caf0f47069ee7cabcdf55fa.svg";